import { Routes } from '@angular/router';
import { authenticationGuard } from '@maersk-global/angular-shared-library';
import { UnsavedChangesGuard } from './common/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'customer-recovery',
    pathMatch: 'full',
  },
  {
    path: 'customer-recovery',
    loadComponent: () =>
      import('./components/customer-recovery/customer-recovery.component').then(
        (c) => c.CustomerRecoveryComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'vendor-recovery',
    loadComponent: () =>
      import('./components/vendor-recovery/vendor-recovery.component').then(
        (c) => c.VendorRecoveryComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'customer-recovery/workflow',
    loadComponent: () =>
      import(
        './components/customer-recovery/customer-recovery-orchestrator/customer-recovery-orchestrator.component'
      ).then((c) => c.CustomerRecoveryOrchestratorComponent),
    canActivate: [authenticationGuard],
  },
  {
    path: 'vendor-recovery/workflow',
    loadComponent: () =>
      import(
        './components/vendor-recovery/vendor-recovery-orchestrator/vendor-recovery-orchestrator.component'
      ).then((c) => c.VendorRecoveryOrchestratorComponent),
    canActivate: [authenticationGuard],
  },
  {
    path: 'admin',
    pathMatch: 'full',
    loadComponent: () =>
      import('./admin/home/admin-home.component').then(
        (c) => c.AdminHomeComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'admin/email-template/edit',
    pathMatch: 'full',
    loadComponent: () =>
      import('./admin/email-template/email-template-edit.component').then(
        (c) => c.EmailTemplateEditComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'admin/user-management',
    pathMatch: 'full',
    loadComponent: () =>
      import('./admin/user/user-management.component').then(
        (c) => c.UserManagementComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'help-faq',
    loadChildren: () =>
      import('./components/help-faq/help-faq.routes').then(
        (x) => x.HelpFaqRoutes
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'error',
    pathMatch: 'full',
    loadComponent: () =>
      import('@maersk-global/angular-shared-library').then(
        (c) => c.ErrorPagesComponent
      ),
  },
  {
    path: 'cp-insights',
    loadComponent: () =>
      import('./components/cp-insights/cp-insights.component').then(
        (c) => c.CpInsightsComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'fea-recoveries',
    loadComponent: () =>
      import(
        './components/fea-recovery/fea-recovery/fea-recovery.component'
      ).then((c) => c.FeaRecoveryComponent),
    canActivate: [authenticationGuard],
  },
  {
    path: 'fea-recoveries/workflow',
    loadComponent: () =>
      import(
        './components/fea-recovery/fea-recovery-orchestrator/fea-recovery-orchestrator.component'
      ).then((c) => c.FeaRecoveryOrchestratorComponent),
    canActivate: [authenticationGuard],
  },
  {
    path: 'dert-images',
    loadComponent: () =>
      import('./components/images/dert-images/dert-images.component').then(
        (c) => c.DertImagesComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'tariffs',
    loadComponent: () =>
      import('./components/tariffs/tariffs.component').then(
        (c) => c.TariffsComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'tariffs/prs-template',
    loadComponent: () =>
      import('./components/tariffs/prs-template/prs-template.component').then(
        (c) => c.PrsTemplateComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'tariffs/prn-template',
    loadComponent: () =>
      import('./components/tariffs/prn-template/prn-template.component').then(
        (c) => c.PrnTemplateComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'tariffs/pre-template',
    loadComponent: () =>
      import('./components/tariffs/pre-template/pre-template.component').then(
        (c) => c.PreTemplateComponent
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'auto-invoice-configuration',
    loadComponent: () =>
      import(
        './components/auto-invoice-configuration/auto-invoice-configuration.component'
      ).then((c) => c.AutoInvoiceConfigurationComponent),
    canActivate: [authenticationGuard],
  },
  {
    path: 'auto-invoice-configuration-edit',
    loadComponent: () =>
      import(
        './components/auto-invoice-configuration/add-update-auto-invoice-configuration/add-update-auto-invoice-configuration.component'
      ).then((c) => c.AddUpdateAutoInvoiceConfigurationComponent),
    canActivate: [authenticationGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'auto-invoice-configuration-add',
    loadComponent: () =>
      import(
        './components/auto-invoice-configuration/add-update-auto-invoice-configuration/add-update-auto-invoice-configuration.component'
      ).then((c) => c.AddUpdateAutoInvoiceConfigurationComponent),
    canActivate: [authenticationGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'cam',
    loadComponent: () =>
      import('./components/cam-exceptions/cam-exceptions.component').then(
        (c) => c.CAMExceptionsComponent
      ),
    canActivate: [authenticationGuard],
  },
];
